import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import * as authActions from './../Auth/authActions';
import * as thematicActions from './../Thematics/thematicsActions';

import Aux from '../../hoc/_Aux';

import Backdrop from '../../containers/UI/Backdrop/Backdrop';
import ClickableIcon from '../../containers/UI/ClickableIcon/ClickableIcon';
import NavigationItems from './../../containers/Navigation/NavigationsItems/NavigationItems';
import Link from './../../containers/UI/Link/Link';

class Menu extends Component {

    state = {}

    logoutAction = (event) => {
        event.preventDefault();
        this.props.onDisconnectClicked();
    }

    loginAction = (event) => {
        event.preventDefault();
        this.props.onConnectClicked();
    }

    goToContactPageHandler = () => {
        this.props.onContactClicked();
    }

    render() {

        let link = (<Link key=''
                          class='menu-logout'
                          clicked={(event) => this.logoutAction(event)}
                          target='#'
        >
            Je me déconnecte
        </Link>);

        if (!this.props.isUserSignedIn) {
            link = (<Link key=''
                          class='menu-logout'
                          clicked={(event) => this.loginAction(event)}
                          target='#'
            >
                Je me connecte
            </Link>);
        }

        return (
            <Aux>
                <Backdrop show={this.props.showMenu} clicked={this.props.toggleAction} fadeAnimation='true'/>

                <div id="main-menu"
                     style={{
                         transform: this.props.showMenu ? 'translateX(260px)' : 'translateX(0px)',
                     }}
                >
                    <div id="menu-toggle" onClick={this.props.toggleAction}>
                        <ClickableIcon class="icon-menu"/>
                    </div>
                    <div className="content">
                        <nav>
                            <NavigationItems links={this.props.thematics} actionClicked={this.props.onThematicClicked}
                                             toggleAction={this.props.toggleAction}
                                             isUserSignedIn={this.props.isUserSignedIn}/>
                        </nav>
                    </div>
                    <div className="menu-actions-panel">
                        <Link key='profile-contact-menu'
                              class='profile-contact'
                              clicked={() => this.goToContactPageHandler()}
                              target='#'>
                            contact
                        </Link>
                        {link}
                    </div>
                </div>

            </Aux>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        uid: state.auth.uid,
        thematics: state.thematics.thematics,
        isUserSignedIn: state.auth.isUserSignedIn
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onThematicClicked: (thematicName) => dispatch(thematicActions.getArticlesByThematic(thematicName)),
        onDisconnectClicked: () => dispatch(authActions.logout()),
        onConnectClicked: () => dispatch(push('/login')),
        onContactClicked: () => dispatch(push('/contact'))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);


// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js